module.exports = __webpack_public_path__ + "img/android-list.70b4cdee.svg";